angular.module('gym.calendar').controller('CancelEventCtrl', ["$scope", "event", function($scope, event) {
  return $scope.event = event.plain();
}]);
